<template>
    <div class="modal" :class="{'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Proforma Invoice #{{ number }}</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <section class="modal-card-body"  v-if="haveNoPricePlan">
                <h1 class="title has-text-centered">Please select a Price Plan for <span class="link" @click="goToUserPage(car.user.id)">{{ car.user.name }}</span> first.</h1>
            </section>
            <section class="modal-card-body"  v-else-if="haveNoPortOfLoading">
                <h1 class="title has-text-centered">Please select a Port Of Loading for this car first.</h1>
            </section>
            <section class="modal-card-body"  v-else-if="errorStatus">
                <h1 class="title has-text-centered">{{ errorMessage }}</h1>
            </section>
            <section class="modal-card-body"  v-else-if="hasNoInvoice">
                <proforma-invoice-select-type-and-details :car="car"></proforma-invoice-select-type-and-details>
            </section>
            <section class="modal-card-body"  v-else="">
                <proforma-invoice-body :car="car"></proforma-invoice-body>
            </section>
            <footer class="modal-card-foot">
                <button class="button"  @click="closeModal">Close</button>
                <button class="button is-primary" v-if="hasNoInvoice && !errorStatus" @click="createProforma">Create</button>
                <button class="button is-primary" v-if="buttonsEnabled && !hasNoInvoice" @click="saveProformaInvoice" :disabled="isLocked">Save</button>
                <button class="button" v-if="buttonsEnabled && !hasNoInvoice" @click="downloadPDF">
                    <span class="icon is-small">
                      <i class="fas fa-file-pdf"></i>
                    </span>
                    <span>Output (PDF)</span>
                </button>
                <button class="button" v-if="buttonsEnabled && !hasNoInvoice" @click="downloadEXCEL">
                    <span class="icon is-small">
                      <i class="fas fa-file-excel"></i>
                    </span>
                    <span>Output (EXCEL)</span>
                </button>
                <button class="button" v-if="buttonsEnabled && !hasNoInvoice" disabled>Last updated @ {{ invoiceUpdateDate }}</button>
                <button class="button is-danger" v-if="isAdmin && buttonsEnabled && !hasNoInvoice" :disabled="isLocked" @click="openProformaDeleteModal">DELETE</button>
                <button class="button is-outlined" @click="lockProformaInvoice" :class="{'is-danger': !isLocked, 'is-primary':isLocked}" v-if="isAdmin">
                    <span class="icon" v-if="isLocked">
                        <i class="fas fa-lock"></i>
                    </span>
                    <span class="icon" v-else>
                        <i class="fas fa-lock-open"></i>
                    </span>
                    <span  v-if="isLocked"> LOCKED</span>
                    <span v-else> UNLOCKED</span>
                </button>
            </footer>
        </div>
        <delete-proforma-modal v-if="isAdmin" :proforma_invoice="invoice" :car="car"></delete-proforma-modal>
    </div>
</template>

<script>
    import ProformaInvoiceBody from './ProformaInvoiceBody'
    import ProformaInvoiceSelectTypeAndDetails from './ProformaInvoiceSelectTypeAndDetails'
    import DeleteProformaModal from "./DeleteProformaModal";
    export default {
        props:['car', 'invoice'],
        components: {
            DeleteProformaModal,
            ProformaInvoiceBody,
            ProformaInvoiceSelectTypeAndDetails
        },
        methods: {
            closeModal() {
                if (this.$store.getters.getProformaInvoice.id == null) {
                    this.car.proforma_invoice = null
                }

                this.setCurrentCarProformaInvoice()
                this.$store.dispatch('changeProformaInvoiceModalStatus', { status: false, carId: null })
                this.$store.dispatch('changeProformaInvoiceToDefault')
                this.$store.dispatch('changeProformaInvoiceQueryToDefault')
            },
            goToUserPage(id){
                this.$router.push({ name: 'EditUser', params: { id: id } });
            },
            downloadPDF() {
                this.$store.dispatch('downloadProformaInvoicePdf')
            },
            downloadEXCEL() {
                this.$store.dispatch('downloadProformaInvoiceExcel')
            },
            saveProformaInvoice() {
                this.$store.dispatch('saveProformaInvoice')
                this.setCurrentCarProformaInvoice()
            },
            createProforma() {
                this.$store.dispatch('createProformaInvoice')
                    .then(this.car.proforma_invoice = this.$store.getters.getProformaInvoice)
            },
            setCurrentCarProformaInvoice() {
                if (this.$store.getters.getProformaInvoice.id !== null) {
                    this.car.proforma_invoice = this.$store.getters.getProformaInvoice
                }
            },
            lockProformaInvoice() {
                let value = this.isLocked ? null : 1
                this.$store.dispatch('changeProformaInvoiceFieldValue', {field: 'locked', value: value})
                this.saveProformaInvoice()
            },
            openProformaDeleteModal(){
                this.$store.dispatch('setProformaDeleteModalStatus', true)
            }
        },
        computed: {
            hasNoInvoice () {
                return this.car.proforma_invoice === null
            },
            number() {
                  return this.$store.getters.getProformaInvoice.id
            },
            isActive() {
                return this.$store.getters.getProformaInvoiceModalStatus(this.car.id)
            },
            haveNoPricePlan() {
                return this.car.user.price_plan === null
            },
            haveNoPortOfLoading() {
                return this.car.port_of_loading === null
            },
            buttonsEnabled() {
                return !this.$store.getters.getProformaInvoiceErrorStatus
            },
            invoiceUpdateDate() {
                return this.$store.getters.getProformaInvoice.updated_at
            },
            errorStatus() {
                return this.$store.getters.getProformaInvoiceErrorStatus
            },
            errorMessage() {
                return this.$store.getters.getProformaInvoiceErrorMessage
            },
            isAdmin() {
                return this.$store.getters.checkIfUserIsAdmin
            },
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 90%;
    }
    .text-button {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    td {
        font-size: large;
    }
    .is-static {
        min-width: 50px;
    }
    th {
        font-size: small;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceModal.vue